import { OptimisticSlice, ArenaStoreState } from '../arenaStoreTypes';
import { Card, BidRecord, TrumpSuit, Direction, SeatPosition } from '../../state/ArenaTypes';

export type StoreSet = (
  partial: Partial<ArenaStoreState> | ((state: ArenaStoreState) => Partial<ArenaStoreState>)
) => void;
export type StoreGet = () => ArenaStoreState;

export const initialOptimisticState = {
  optimisticSeat: null as SeatPosition | null,
  optimisticReady: null as boolean | null,
  optimisticBid: null as BidRecord | null,
  optimisticTrump: null as { suit: TrumpSuit; direction?: Direction } | null,
  optimisticDiscards: null as string[] | null,
  optimisticPlay: null as { card: Card; seat: SeatPosition } | null,
  optimisticGameExtension: null as Record<string, any> | null,
};

export const createOptimisticSlice = (
  set: StoreSet,
  _get: StoreGet,
  triggerRecompute: () => void
): OptimisticSlice => ({
  ...initialOptimisticState,

  setOptimisticSeat: (updater) => {
    set((state) => ({
      optimisticSeat: typeof updater === 'function' ? updater(state.optimisticSeat) : updater,
    }));
    triggerRecompute();
  },

  setOptimisticReady: (updater) => {
    set((state) => ({
      optimisticReady: typeof updater === 'function' ? updater(state.optimisticReady) : updater,
    }));
    triggerRecompute();
  },

  setOptimisticBid: (updater) => {
    set((state) => ({
      optimisticBid: typeof updater === 'function' ? updater(state.optimisticBid) : updater,
    }));
    triggerRecompute();
  },

  setOptimisticTrump: (updater) => {
    set((state) => ({
      optimisticTrump: typeof updater === 'function' ? updater(state.optimisticTrump) : updater,
    }));
    triggerRecompute();
  },

  setOptimisticDiscards: (updater) => {
    set((state) => ({
      optimisticDiscards: typeof updater === 'function' ? updater(state.optimisticDiscards) : updater,
    }));
    triggerRecompute();
  },

  setOptimisticPlay: (updater) => {
    set((state) => ({
      optimisticPlay: typeof updater === 'function' ? updater(state.optimisticPlay) : updater,
    }));
    triggerRecompute();
  },

  setOptimisticGameExtension: (updater) => {
    set((state) => ({
      optimisticGameExtension: typeof updater === 'function' ? updater(state.optimisticGameExtension) : updater,
    }));
    triggerRecompute();
  },

  clearOptimisticGameplay: () => {
    set({
      optimisticBid: null,
      optimisticTrump: null,
      optimisticDiscards: null,
      optimisticPlay: null,
      optimisticGameExtension: null,
    });
    triggerRecompute();
  },
});
